import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=1e2acfab&scoped=true"
import script from "./Resource.vue?vue&type=script&lang=ts"
export * from "./Resource.vue?vue&type=script&lang=ts"
import style0 from "./Resource.vue?vue&type=style&index=0&id=1e2acfab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2acfab",
  null
  
)

export default component.exports